import { OrgSettings } from 'components/Customize/OrgSettings/Helpers'
import { makeDefaultFailedContainer } from 'components/container'

export default (Target) => makeDefaultFailedContainer(Target, {
  listenTo: [
    'stores.OrgSettingsStore',
    'stores.LocaleStore',
    'stores.TranslationStore'
  ],
  fetch: {
    orgSettings() {
      return this.app.stores.OrgSettingsStore.getOrgSettings()
    },
    locale() {
      return this.app.stores.LocaleStore.loadLocale()
    },
    messages() {
      return this.app.stores.TranslationStore.getTranslationsForLocale()
    },
  },
  pending() {
    return this.done({
      orgSettings: OrgSettings(),
      messages: this.app.stores.TranslationStore.state.get('en')
    })
  }
})



// WEBPACK FOOTER //
// ./src/scripts/components/I18n/IntlContainer.js